var map = {
	"./add.svg": 1480,
	"./btnFirst.svg": 829,
	"./btnLast.svg": 4185,
	"./btnNext.svg": 7726,
	"./btnPrior.svg": 5175,
	"./check.svg": 2497,
	"./close.svg": 5837,
	"./download.svg": 1303,
	"./drive.svg": 7793,
	"./edit.svg": 975,
	"./eraser.svg": 7931,
	"./file-download.svg": 5026,
	"./file-x.svg": 8302,
	"./information.svg": 3787,
	"./mail.svg": 9814,
	"./map.svg": 9543,
	"./mapMarker.svg": 2269,
	"./mapMarker2.svg": 9013,
	"./mapMarker3.svg": 3380,
	"./menu.svg": 2434,
	"./menuCadastros.png": 1818,
	"./menuCadastros.svg": 6682,
	"./menuColetas.png": 2487,
	"./menuCollapse.png": 293,
	"./menuCollapse.svg": 723,
	"./menuDoc1.svg": 3897,
	"./menuDoc2.svg": 7898,
	"./menuDocumentos.png": 4077,
	"./menuEditUser.png": 3013,
	"./menuEstabelecimentos.png": 3766,
	"./menuExpand.svg": 9630,
	"./menuExpedicao.svg": 7324,
	"./menuFolder.svg": 5410,
	"./menuHelp.svg": 9635,
	"./menuHistory.png": 7906,
	"./menuHoney.svg": 5499,
	"./menuIndustry.svg": 8048,
	"./menuLogout.png": 7902,
	"./menuLogout.svg": 7296,
	"./menuManager.svg": 1119,
	"./menuMap.svg": 3920,
	"./menuMilk.svg": 3919,
	"./menuOffice.svg": 7218,
	"./menuOpcoes.svg": 6137,
	"./menuPass.png": 327,
	"./menuPrinter.png": 2402,
	"./menuProcessos.svg": 1287,
	"./menuProducao.png": 8211,
	"./menuRAC.png": 808,
	"./menuRacPendentes.png": 6656,
	"./menuRotulos.png": 6844,
	"./menuRt.png": 7350,
	"./menuSettings.svg": 5473,
	"./menuSims.png": 7008,
	"./menuStock.svg": 224,
	"./menuTable.svg": 9686,
	"./menuUsers.png": 3782,
	"./menuVistorias.png": 3752,
	"./menuVistorias.svg": 4624,
	"./microscope.svg": 2631,
	"./module.svg": 8019,
	"./office1.svg": 4180,
	"./office2.svg": 2039,
	"./office3.svg": 4918,
	"./office4.svg": 153,
	"./office5.svg": 2232,
	"./office6.svg": 3595,
	"./pass.svg": 2116,
	"./pdfFile.svg": 2285,
	"./printer.svg": 9049,
	"./search.svg": 4343,
	"./trash.svg": 6891,
	"./unlink.svg": 5482,
	"./view.svg": 3436,
	"./workflow1.svg": 6989,
	"./workflow2.svg": 4014,
	"./workflow3.svg": 8655,
	"./workflow4.svg": 1184,
	"./workflow5.svg": 5569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;